<nav
    class="navbar"
    [ngClass]="{
        isScroll: scroll,
        isScrollAndBenefits: isBenefits,
        'has-mobile-breadcrumb': hasMobileBreadcrumb,
        'hide-submenu': withoutSubMenu$ | async,
        'has-app-banner': showAppBanner
    }"
>
    <div class="navbar-wrapper flex-column">
        <ng-container *ngIf="!!showAlert">
            <edp-alert class="d-block w-100"></edp-alert>
        </ng-container>

        <!-- HEADER DESKTOP -->
        <div class="d-none d-lg-flex align-items-center ml-auto pr-5" [ngClass]="{'light-icon': !!isDashboard}">
            <div *edpConditionalRegion="'pt.edp.edponline.contract.header.store'">         
                <a
                    class="px-3"
                    [attr.href]="'pt.edp.edponline.header.carrinho.link' | translate"
                    [edpExternalLink]="'pt.edp.edponline.header.carrinho.link' | translate"
                    [gaClickDatalayer]="'topbarMenuStore'"
                    target="_blank"
                    rel="noopener"
                >
                    <i class="icon icon-edponline-Bop-083 icon-2x" aria-hidden="true"></i>
                </a>
            </div>
            <a class="px-3" (click)="selectOverlay('user')" [gaClickDatalayer]="'topbarMenuProfile'">
                <i id="edp-tour-icon-entrada" class="icon icon-edponline-Bop-081 icon-2x" aria-hidden="true"></i>
            </a>
            <div *edpConditionalRegion="'pt.edp.edponline.contract.header.notifications'">
                <a class="px-3" (click)="selectOverlay('notifications')">
                    <i id="edp-tour-notifications" class="icon icon-edponline-Bop-030 icon-2x" aria-hidden="true"></i>
                    <div class="number-notifications" *ngIf="totalNotificationsNotViewed > 0">
                        <span>{{ totalNotificationsNotViewed }}</span>
                    </div>
                </a>
            </div>
        </div>
        <!-- HEADER MOBILE -->
        <div class="d-flex d-lg-none w-100">
            <a [routerLink]="link" class="logo pl-2 d-inline-flex align-self-center">
                <!-- <img src="./assets/images/stella-images/logo.png" width="30" height="30" alt="Edp Online" /> -->
                <img src="assets/images/stella-images/edp_logo_rgb_dark_neg.svg" width="80" height="25" alt="Edpe Online"/>
            </a>
            <div class="d-flex align-items-center ml-auto">
                <div *edpConditionalRegion="'pt.edp.edponline.contract.header.store'"> 
                    <a
                        class="pl-2 pr-3"
                        [attr.href]="'pt.edp.edponline.header.carrinho.link' | translate"
                        [edpExternalLink]="'pt.edp.edponline.header.carrinho.link' | translate"
                        [gaClickDatalayer]="'topbarMenuStore'"
                        target="_blank"
                        rel="noopener"
                    >
                        <i class="icon icon-edponline-Bop-083 icon-2x" aria-hidden="true"></i>
                    </a>
                </div>
                <a class="pr-3" (click)="selectOverlay('user')" [gaClickDatalayer]="'topbarMenuProfile'">
                    <i id="edp-tour-mobile-icon-entrada" class="icon icon-edponline-Bop-081 icon-2x" aria-hidden="true"></i>
                </a>
                <div *edpConditionalRegion="'pt.edp.edponline.contract.header.notifications'">
                    <a class="pr-3" (click)="selectOverlay('notifications')">
                        <i id="edp-tour-mobile-notifications" class="icon icon-edponline-Bop-030 icon-2x" aria-hidden="true"></i>
                        <div class="number-notifications" *ngIf="totalNotificationsNotViewed > 0">
                            <span>{{ totalNotificationsNotViewed }}</span>
                        </div>
                    </a>
                </div>
                <a (click)="openSidebar()" class="p-2 pr-3 d-block">
                    <i class="icon-edponline-Bop-077 icon-2x" aria-hidden="true"></i>
                </a>
            </div>
        </div>

        <edp-breadcrumb-mobile (hasMobileBreadcrumb)="showMobileBreadcrumb($event)"></edp-breadcrumb-mobile>
    </div>
</nav>
